//仓库类型
export enum WarehouseSiteType {
    HUB = "HUB",
    WAREHOUSE = "WAREHOUSE"
}

/**
 * 仓库业务类型（与后端 warehouse.business_type / WarehouseBusinessType 一致）
 * 0-未设置 1-分拨(Sorting) 2-尾程(LastMile)
 */
export enum WarehouseBusinessType {
    UNSET = 0,
    SORTING = 1,
    LAST_MILE = 2,
}